export default (input: RequestInfo, init?: RequestInit): Promise<Response> =>
  fetch(input, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...init,
  });
